require.register("app/restaurant/user/Form", function(exports, require, module){
  $0
  
});

